const { checkCompatEnabled } = require("@vue/compiler-core");

// Connect Sass
require("./assets/scss/index.scss");


// // Connect SVG Sprite
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./assets/images/sprite', true, /\.svg$/));

window.addEventListener('load', () => {
	// Loading
  document.body.classList.remove('before-load');

  document.querySelector('.loading').addEventListener('transitionend', e => {
    document.body.removeChild(e.currentTarget);
  });

	// video load
	document.querySelector('.videoArea__main').style.display = 'block';

	const videoAll = document.querySelectorAll('.videoArea video');
	for(i=0; i<videoAll.length; i++){
		videoAll[i].play();
	}
});


//언어 버튼
const lngBtn = document.querySelector(".languageArea");
const body = document.querySelector("body");
const lngArea = document.querySelector(".language__dropdown");

function lngBtnEvent(){
	//언어 드롭다운 클릭버전
	body.addEventListener("click", (e)=>{
		if(e.target === lngBtn){
			lngArea.classList.toggle("on");
		} else{
			lngArea.classList.remove("on");
		}
	});

	//언어 드롭다운 마우스오버 버전
	// lngBtn.addEventListener("mouseover",()=>{
	// 	lngArea.classList.add("on");
	// });
	// lngBtn.addEventListener("mouseout",()=>{
	// 	lngArea.classList.remove("on");
	// });
}
lngBtnEvent();


//modal
const modalBtn = document.querySelectorAll(".is-modal");
const modal = document.querySelectorAll(".modal");
const closeBtn = document.querySelectorAll(".is-close");
const resetBtn = document.querySelector(".modal__btnArea .is-reset");
const modalInput = document.querySelectorAll(".modal__form input");
const termCheck = document.querySelector(".modal__term input");
const modalSubmit = document.querySelector(".modal .is-submit");
const emailInput = document.getElementById('ipt1-2');
const lang = document.documentElement.lang;

function removeModal() {
	for(let j=0; j<closeBtn.length; j++){
		closeBtn[j].closest(".modal").classList.remove("is-active");
		body.classList.remove("is-hidden");
	}
}

function loadingShow(){
	for(let i=0; i<modal.length; i++){
		modal[i].classList.add('before-load');
	}
}
function loadingHide(){
	for(let i=0; i<modal.length; i++){
		modal[i].classList.remove('before-load');
	}
}

function removeInfo() {
	for(let i=0; i < modalInput.length; i++){
		modalInput[i].checked = "";
		modalSubmit.disabled = true; 
		termCheck.checked = false;
	}
	document.getElementById('ipt1-2').value = "";
	document.getElementById('ipt1-2').className = "modal__input";
	document.querySelector(".modal__term input").checked=false;
	document.getElementsByClassName('message')[0].innerText = "";
}

function popup(){
	for(let i=0; i<modalBtn.length; i++){ 
		modalBtn[i].addEventListener('click', (e)=> {
			pop = modalBtn[i].name;
			const popWrap = document.querySelector(`.${pop}`);
			popWrap.classList.add("is-active");
			body.classList.add("is-hidden");
		});
	}	

	for(let j=0; j<closeBtn.length; j++){
		closeBtn[j].addEventListener('click', (e)=> {
			closeBtn[j].closest(".modal").classList.remove("is-active");
			body.classList.remove("is-hidden");
			removeInfo();
		});
	}

	resetBtn.addEventListener("click",()=>{
		removeInfo();
	});

	const termChk = document.querySelector('.termChk');
	const chk = document.querySelectorAll('.termChk input');
	termChk.addEventListener('click', (e) => {
		const target = e.target;
		let chkNum = 0;
		if(target.checked === true){
			for(let i = 0; i < chk.length; i++){
				if(chk[i].checked){
					chkNum++;
					console.log(chkNum);
					console.log(chk.length -1);
				};
			}
			if(chkNum >= chk.length){
				modalSubmit.disabled = false; 
			}
		}else{
			modalSubmit.disabled = true; 
		}
	});


	// for(let i=0; i<termCheck.length; i++){
	// 		termCheck[i].addEventListener("click", ()=>{
	// 		if(termCheck[i].checked == false){
	// 			modalSubmit.disabled = true; 
	// 		}else if(termCheck[i].checked == true){
	// 			modalSubmit.disabled = false; 
	// 		}
	// 	});
	// }

	modalSubmit.addEventListener("click", ()=>{
		let emailAddress = document.getElementById("ipt1-2").value;
		let validationEmail =/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
		if(emailAddress == null || emailAddress == "" || emailAddress == "undefined" || !validationEmail.test(emailAddress)){
			if(lang == "ko"){
				alert("이메일 주소를 확인해 주세요.");
			}else{
				alert("Enter a valid email address")
			}
			return;
		}

		const checkGenderInfo = document.querySelector('input[name="ipt2"]:checked');
		if(checkGenderInfo == null || checkGenderInfo == "" || checkGenderInfo == "undefined"){
			if(lang == "ko"){
				alert("성별을 선택해 주세요");
			}else{
				alert("please select sex");
			}
			return;
		}
		let gender = document.querySelector('input[name="ipt2"]:checked').value;
	 
		const checkAge = document.querySelector('input[name="ipt3"][type="radio"]:checked');
		if(checkAge == null || checkAge == "" || checkAge == "undefined"){
			if(lang == "ko"){
				alert("나이를 선택해 주세오.")
			}else{
				alert("please select age")
			}
		   return;
		}
		let age = document.querySelector('input[name="ipt3"][type="radio"]:checked').value;

		let preregisterInfo = {
	   		"emailAddress" : emailAddress,
	   		"gender" : gender,
	   		"age" : age,
			"language" : lang
		}
	 
		$.ajax({
			type: 'post',
			url : location.origin+'/api/preregister',
			data:  JSON.stringify(preregisterInfo),
			dataType : "json",
			contentType: "application/json; charset=utf-8",
			beforeSend : function(){
				loadingShow();
			},
			success: function(result){
				removeInfo();
				removeModal();
				alert(result);
			},
			complete: function() {
				loadingHide();
			},
			error:function(err){
				alert(err.responseJSON);
			}
		});
	 });

	emailInput.addEventListener("keyup", (value)=>{
		let emailAddress = document.getElementById("ipt1-2").value;
		let validationEmail =/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
		if(emailAddress != null && emailAddress != "" && emailAddress != "undefined" && validationEmail.test(emailAddress)){
			document.getElementById('ipt1-2').className = "modal__input";
			document.getElementsByClassName('message')[1].innerText = '';
		}else{
			document.getElementById('ipt1-2').className = "modal__input is-error";
			if(lang == "ko"){
				document.getElementsByClassName('message')[1].innerText = '! 유효한 이메일 주소를 입력하세요';
			}else{
				document.getElementsByClassName('message')[1].innerText = '! Enter a valid email address';
			}
		}
	});
}
popup();


//parallax
function parallax(){

	let yOffset = 0;
	let prevScrollHeight = 0;
	let currentScene = 0;
	let enterNewScene = false;
	let acc = 0.2;
	let delayedYOffset = 0;
	let rafId;
	let rafState;

	const sceneInfo = [
		{
			//0 
			type:'sticky', 
			heightNum:2,
			scrollHeight:0,
			objs:{ 
				header : document.querySelector("header"),
				container : document.querySelector(".section0"),
				mainVideo : document.querySelector(".section0 .videoArea"),
				msgA : document.querySelector(".section0 .msgA .titleArea__titleL"),
				msgB : document.querySelector(".section0 .msgB"),
				scroll : document.querySelector(".section0 .scrollArea"),
				videoArea : document.querySelector(".section1 .videoArea"),
				video : document.querySelector(".section1 .videoArea video"),
				title : document.querySelector(".section1 .titleArea"),
			},
			values:{
				videoHeight: [80, 100, {start:0, end:0}],	
				rect: [ 0, 0, { start: 0, end: 0 } ],
				videoScale : [0, 0, {start:0, end:0}],
				rectStartY : 0,
				bannerTrans : [0, -30, {start:0, end:1}],
				title_opacity : [1, 0, {start:0, end:0.3}],
				title_translate: [0, -20, {start:0.0, end:0.3}],
				title2_opacity : [0, 1, {start:0.3, end:0.45}],
				title2_translate: [5, 0, {start:0.3, end:0.45}],
				title3_opacity : [0, 1, {start:0.85, end:1}],
				title3_translate: [20, 0, {start:0.85, end:1}],
				title3_opacity_mo : [0, 1, {start:0.55, end:0.75}],
				title3_translate_mo: [20, 0, {start:0.55, end:0.75}],
				scroll_opacity : [0, 1, {start:0.3, end:0.45}],
				scroll_translate: [20, 0, {start:0.3, end:0.45}],
				header_opacity: [1, 0, {start:0.6, end:0.8}],
			}
		},
		{
			//1
			type:'sticky',
			heightNum:1.5,
			scrollHeight:0,
			objs:{
				section0 : document.querySelector(".section0"),
				container : document.querySelector('.section1'),
				title : document.querySelector(".section1 .titleArea"),
				videoArea : document.querySelector(".section1 .videoArea"),
				video : document.querySelector(".section1 .videoArea video"),
				banner : document.querySelector(".section1 .bannerArea__roller"),
				topBtn : document.querySelector(".floatingArea .is-top"),
			},
			values:{
				videoWidth: [50, 100, {start:0.05, end:0}],	
				videoHeight: [70, 100, {start:0.05, end:0}],	
				rect: [0, 0, { start:0, end:0} ],
				rectStartY : 0,
				bannerTrans : [-30, 0, {start:0, end:1}],
				top_opacity : [0, 1, {start:0, end:0.1}],
				top_transform : [20, 0, {start:0, end:0.1}],
			}
		 },
		{
			//2
			type:'sticky',
			heightNum:4,
			scrollHeight:0,
			objs:{
				container : document.querySelector('.section2'),
				sticky : document.querySelector('.section2 .is-sticky'),
				imgCon : document.querySelector(".section2 .img__content.pc"),
				imgCon2 : document.querySelector(".section2 .img__content.mo"),
				imgArea : document.querySelector(".section2 .is-scroll"),
				imgA : document.querySelector(".section2 .imgArea__bg"),
				imgB : document.querySelector(".section2 .imgArea__bg .img__leftArea"),
				imgC : document.querySelector(".section2 .img__after img"),
				imgD : document.querySelector(".section2 .img__after"),
				imgText : document.querySelector(".section2 .imgArea__bg .img__message"),
				imgText2 : document.querySelector(".section2 .img__content.mo .img__message"),
				videoArea : document.querySelector(".section3 .videoArea"),
				video : document.querySelector(".section3 .videoArea video"),
			},
			values: {
				imgCon_opacity: [0, 1, {start:0.05, end:0.15}],
				imgCon2_opacity: [0, 1, {start:0, end:0.2}],
				imgA_clip: [0, 100, {start:0.25, end:0.7}],
				imgD_height: [0, 100, {start:0.1, end:0.4}],
				imgD_translate: [0, 300, {start:0.45, end:0.65}],
				imgText_opacity: [0, 1, {start:0.35, end:0.55}],
				imgText_transition: [-30, -50, {start:0.35, end:0.55}],
				imgText2_opacity: [0, 1, {start:0.55, end:0.65}],
				imgText2_transition: [-30, -50, {start:0.55, end:0.65}],
				title3_opacity: [0, 1, {start:0.85, end:1}],
				title3_transition: [20, 0, {start:0.85, end:1}],
				title3_opacity_mo: [0, 1, {start:0.75, end:0.9}],
				title3_transition_mo: [20, 0, {start:0.75, end:0.9}],
				imgB_left: [0, 160,{start:0.7, end:0.9}],
				imgText_left: [0, 160,{start:0.7, end:0.9}],
				videoHeight: [80, 100, {start:0, end:0}],	
				rect: [ 0, 0, { start: 0, end: 0 } ],
				videoScale : [0, 0, {start:0, end:0}],
				rectStartY : 0,
			}
		},
		{
			//3
			type:'normal',
			//heightNum:1.5,
			scrollHeight:0,
			objs:{
				container : document.querySelector('.section3'),
				videoArea : document.querySelector(".section3 .videoArea"),
				video : document.querySelector(".section3 .videoArea video"),
				title : document.querySelector(".section3 .titleArea"),
				title2 : document.querySelector(".section4 .titleArea"),
			},
			values:{
				videoWidth: [50, 100, {start:0, end:0}],	
				videoHeight: [50, 100, {start:0, end:0}],	
				rect: [ 0, 0, { start: 0, end: 0 } ],
				rectStartY : 0,
				title_opacity: [0, 1, {start:0., end:0.2}],
				title_transition: [20, 0, {start:0., end:0.2}],
				title_opacity_mo: [0, 1, {start:0.9, end:1}],
				title_transition_mo: [20, 0, {start:0.9, end:1}],
				title2_opacity: [0, 1, {start:0.8, end:1}],
				title2_transition: [20, 0, {start:0.8, end:1}],
				title2_opacity_m: [0, 1, {start:0, end:0.15}],
				title2_transition_m: [20, 0, {start:0, end:0.15}],
			}
		},
		{
			//4
			type:'normal',
	//		heightNum:12,
			scrollHeight:0,
			objs:{
				container : document.querySelector('.section4'),
				video : document.querySelector('.section4 .videoArea video'),
			},
			values:{
			}
		},
		{
			//5
			type:'sticky',
			heightNum:1.8,
			scrollHeight:0,
				imgCon : document.querySelector('.section5 .imgArea'),
				objs:{
				container : document.querySelector('.section5'),
				imgArea : document.querySelector('.section5 .img__scale'),
				imgCon : document.querySelector('.section5 .imgArea'),
				phone : document.querySelector('.section5 .img__phone'),
				phone_in : document.querySelector('.section5 .img__display'),
				imgBg : document.querySelector('.section5 .imgArea__bg'),
				title : document.querySelector(".section5 .titleArea"),
			},
			values:{
				phoneIn_scale: [0, 0, {start:0.0, end:0}], 
				phone_scale: [0, 0, {start:0, end:0}],
				phoneIn_height: [30, 16, {start:0, end:0.6}], 
				phone_height: [100, 84, {start:0, end:0.6}], 
				title_opacity: [0, 1, {start:0, end:0}],
				title_transition: [20, 0, {start:0, end:0}],
				title_opacity_mo: [0, 1, {start:0.2, end:0.4}],
				title_transition_mo: [20, 0, {start:0.2, end:0.4}],
				img_scale : [0, 0, {start:0, end:0}],
				rectStartY: 0,
			}
		},
		{
			//6
			type:'normal',
		//	heightNum:1.5,
			scrollHeight:0,
			objs:{
				container : document.querySelector('.section6'),
				imgText : document.querySelector(".beta__imgText"),
			},
			values:{
				canvas_scale: [0, 0, {start:0, end:0}],
				textTransform: [0, 360, {start:0, end:1}]
			}
		},
	]

	//layout
	function setLayout(){
		for(let i=0; i<sceneInfo.length; i++){
			if(sceneInfo[i].type === 'sticky'){
				sceneInfo[i].scrollHeight = sceneInfo[i].heightNum * window.innerHeight;
			} else if(sceneInfo[i].type === 'normal'){
				sceneInfo[i].scrollHeight = sceneInfo[i].objs.container.offsetHeight;
			}
			sceneInfo[i].objs.container.style.height = `${sceneInfo[i].scrollHeight}px`;
		}

		yOffset = window.pageYOffset;
		let totalScrollHeight = 0;
		for(let i=0; i<sceneInfo.length; i++){
			totalScrollHeight += sceneInfo[i].scrollHeight;
			if(totalScrollHeight >= pageYOffset){
				currentScene = i;
				break;
			}
		}
		document.body.setAttribute('class', `is-show__section${currentScene}`);

		const heightRatio = window.innerHeight / 1080;
	}

	function calcValues(values, currentYOffset){
		let rv;
		const scrollHeight = sceneInfo[currentScene].scrollHeight; 
		const scrollRatio = currentYOffset / scrollHeight; 
		
		if(values.length === 3){ 
			const partScrollStart = values[2].start * scrollHeight;
			const partScrollEnd = values[2].end * scrollHeight; 
			const partScrollHeight = partScrollEnd - partScrollStart;	

			if(currentYOffset >= partScrollStart && currentYOffset <= partScrollEnd ){
				rv = (currentYOffset - partScrollStart) / partScrollHeight * (values[1] - values[0]) + values[0]; 
			} else if(currentYOffset < partScrollStart){ 
				rv = values[0];
			} else if(currentYOffset > partScrollEnd){ 
				rv = values[1];
			}
		
		}else{
			rv = scrollRatio * (values[1] - values[0]) + values[0]; 
		}
		return rv;
	}

	//전체 스크롤 애니메이션 (플로팅 버튼 텍스트 애니메이션)
	function scrollRotate() {
		const beta = document.getElementsByClassName("beta__imgText");
		beta[0].style.transform = "translate3d(-50%, -50%, 0) rotate("+ window.pageYOffset /  document.body.scrollHeight * 360 + "deg) scale3d(1, 1, 1)"
	}

	function playAnimation(){ //애니메이션 처리
		const objs = sceneInfo[currentScene].objs;
		const values = sceneInfo[currentScene].values;
		const currentYOffset = yOffset - prevScrollHeight; 
		const scrollHeight = sceneInfo[currentScene].scrollHeight; 
		const scrollRatio = currentYOffset / scrollHeight; 

		//탑 버튼 클릭시 상단으로 이동 및 상단 애니메이션 초기화
		const btnTop = document.querySelector(".floatingArea .is-top");
		btnTop.addEventListener("click",(e)=>{
			window.location.reload();
			scrollTo(0,0);
			body.className = "is-show__section0"
			btnTop.classList.remove("active");
			sceneInfo[1].objs.video.style.position = "relative";
			sceneInfo[2].objs.sticky.style.position = "relative";
			sceneInfo[2].objs.imgA.style.clip = `rect(0, 0vw, 100vh, 0)`; 
			sceneInfo[2].objs.imgCon.style.opacity = `0`; 
			sceneInfo[0].objs.mainVideo.style.opacity = "1";
			sceneInfo[0].objs.msgA.style.transform = "0";
			sceneInfo[0].objs.msgB.style.opacity = "0"
			sceneInfo[0].objs.scroll.style.opacity = "0";
			sceneInfo[0].objs.header.style.opacity = "1";
			sceneInfo[5].objs.imgArea.style.position ="relative";
		});

		const horizontal = window.innerWidth /2;
		
		// section5 pc 버전 높이값 세팅
		if(window.innerWidth > 1024){
			sceneInfo[5].scrollHeight = 1600;
			sceneInfo[5].objs.container.style.height = `${sceneInfo[5].scrollHeight}px`;

			// 브라우저 넓이 좁을때
			if( 1350 >= window.innerWidth ){
				sceneInfo[5].scrollHeight = 1300;
				sceneInfo[5].objs.container.style.height = `${sceneInfo[5].scrollHeight}px`;
			}
		}

		//section5 모바일/태블릿 버전 높이값 세팅
		if(window.innerWidth < 768){
			if(window.innerWidth <= window.innerHeight){ // 모바일 세로모드
				sceneInfo[5].scrollHeight = 1.5 * window.innerHeight;
				sceneInfo[5].objs.container.style.height = `${sceneInfo[5].scrollHeight}px`;
			}
			if(window.innerWidth > window.innerHeight && window.innerHeight <= 768){ // 모바일 가로모드
				sceneInfo[5].scrollHeight = 2.3 * window.innerHeight;
				sceneInfo[5].objs.container.style.height = `${sceneInfo[5].scrollHeight}px`;
			}
		} 
		if(768 <= window.innerWidth && window.innerWidth <= 1024){
			if(window.innerWidth <= window.innerHeight){ // 태블릿 세로모드
				sceneInfo[5].scrollHeight = 1.35 * window.innerHeight;
				sceneInfo[5].objs.container.style.height = `${sceneInfo[5].scrollHeight}px`;
			}
		}

		//section5 이미지 크기 미리 세팅
		const widthRatio2 = window.innerWidth / sceneInfo[5].objs.imgArea.offsetWidth;
		const heightRatio2 = window.innerHeight / sceneInfo[5].objs.imgArea.offsetHeight;
		let canvasScaleRatio2;

		if (widthRatio2 <= heightRatio2) {
			// 캔버스보다 브라우저 창이 홀쭉한 경우
			canvasScaleRatio2 = heightRatio2;
		} else {
			// 캔버스보다 브라우저 창이 납작한 경우
			canvasScaleRatio2 = widthRatio2;
		}

		// section5 이미지 기본 세팅
		sceneInfo[5].objs.imgArea.style.position = "relative";
		sceneInfo[5].objs.imgBg.style.height = `${sceneInfo[5].objs.phone.offsetHeight - 7}px`;
		sceneInfo[5].objs.imgArea.style.top = `${-(sceneInfo[5].objs.imgArea.offsetHeight - sceneInfo[5].objs.imgArea.offsetHeight * canvasScaleRatio2) / 2}px`;

		//section5 pc 버전 이미지 크기 미리 세팅
		if(window.innerWidth > 1024){
			sceneInfo[5].objs.imgArea.style.transform = `scale(${canvasScaleRatio2 + 0.05})`;
			if(horizontal >= window.innerHeight){
				sceneInfo[5].objs.imgArea.style.transform = `scale(${canvasScaleRatio2 + 0.1})`;
			}
		}

		//section5 모바일 버전 이미지 크기 미리 세팅
		if(window.innerWidth <= 1024){
			sceneInfo[5].objs.imgArea.style.transform = `scale(${canvasScaleRatio2 + 0.2})`;
		}

		//섹션별 애니메이션
		switch(currentScene){
			case 0: //section0

				//top버튼 초기화
				sceneInfo[1].objs.topBtn.classList.remove("active");
				objs.title.style.opacity = 0;
				objs.title.style.transform = `translate3d(0, 0%, 0)`;

				//상단 영상 타이틀 애니메이션
				if(scrollRatio >= 0){
					objs.mainVideo.style.opacity = calcValues(values.title_opacity, currentYOffset);
					objs.msgA.style.transform = `translate3d(0, ${calcValues(values.title_translate, currentYOffset)}%, 0)`;
				}	
				if(scrollRatio >= 0.3){
					objs.msgB.style.opacity = calcValues(values.title2_opacity, currentYOffset);
					objs.msgB.style.transform = `translate3d(0, ${calcValues(values.title2_translate, currentYOffset)}%, 0)`;
					objs.scroll.style.opacity = calcValues(values.scroll_opacity, currentYOffset);
					objs.scroll.style.transform = `translate3d(-50%, ${calcValues(values.scroll_translate, currentYOffset)}, 0)`;
					objs.header.style.opacity = calcValues(values.header_opacity, currentYOffset);
				}
				if(scrollRatio >= 0.7){
					objs.header.style.position = "absolute";
				}

				// 헤더 고정/해제 세팅
				if(scrollRatio < 0.7){
					objs.header.style.position = "fixed";	
				}
				if(scrollRatio < 0.3){
					objs.msgB.style.opacity = 0;
					objs.scroll.style.opacity = 0;
				}

				// section1 비디오 세팅
				const rectStart20Y = sceneInfo[1].objs.video.getBoundingClientRect().top

				const videoHeight20 = sceneInfo[1].objs.video.scrollHeight;

				if(videoHeight20 <= rectStart20Y){
					sceneInfo[1].objs.video.play();
					sceneInfo[1].objs.video.style.width = "1280px";
				}

				//section1 video 고정 해제
				sceneInfo[1].objs.video.style.position = "relative";

				//section1 배너
				if(scrollRatio <= 1){
					sceneInfo[1].objs.banner.style.transform = `translateX(${calcValues(values.bannerTrans, currentYOffset)}%)`;
				}

				//section1 타이틀 애니메이션
				if (scrollRatio >= 0.85) {
					// in
					objs.title.style.opacity = calcValues(values.title3_opacity, currentYOffset);
					objs.title.style.transform = `translate3d(0, ${calcValues(values.title3_translate, currentYOffset)}%, 0)`;
				} 

				sceneInfo[2].objs.sticky.style.position ="absolute";

				//모바일
				if(window.innerWidth < 768){
					if (scrollRatio >= 0.5) {
						// in
						objs.title.style.opacity = calcValues(values.title3_opacity_mo, currentYOffset);
						objs.title.style.transform = `translate3d(0, ${calcValues(values.title3_translate_mo, currentYOffset)}%, 0)`;
					} 
				}

				break;

			case 1: //section1
				
				// top버튼 보이게
				if(scrollRatio >= 0){
					objs.topBtn.classList.add("active");
				}

				//배너
				if(scrollRatio <= 0){
					objs.banner.style.transform = `translateX(${calcValues(values.bannerTrans, currentYOffset)}%)`;

					sceneInfo[1].objs.video.style.position = "relative";
				}
				sceneInfo[0].objs.title.style.opacity = "1";

				// 영상 확대 애니메이션
				const rectStartY = objs.videoArea.getBoundingClientRect().top
				const rectStart2Y = objs.video.getBoundingClientRect().top
				const scaleEnd = rectStartY / scrollHeight ;

				values.videoHeight[2].start = (window.innerHeight / 2) / scrollHeight - 0.2; 
				values.videoHeight[2].end = values.videoHeight[2].start + 0.2;
				values.videoWidth[2].start = (window.innerHeight / 2) / scrollHeight - 0.5; 
				values.videoWidth[2].end = values.videoWidth[2].start + 0.5;

				objs.video.style.width = `${calcValues(values.videoWidth, currentYOffset)}%`;

				// 영상이 상단에 도달하면 화면 고정 
				// section 2 -> section1로 돌아갈때 영상 넓이 재설정
				if(scaleEnd <= 0){
					objs.video.style.position = "fixed";
					objs.video.style.width = `100%`;
				}
				if(scaleEnd >= 0){
					objs.video.style.position = "absolute";
					objs.video.style.width = `${calcValues(values.videoWidth, currentYOffset)}%`;
				}
				
				// 영상이 스크롤 시작할 때 영상 재생
				const videoHeight = objs.video.scrollHeight;

				if(videoHeight + 0.2 <= rectStart2Y){
					objs.video.play();
				}

				//모바일
				if(window.innerWidth < 768){
					objs.video.style.width = `auto`;
					objs.video.style.height = `auto`;
					if(scaleEnd < 0){
						objs.video.style.position = "relative";
						objs.video.style.width = `auto`;
						objs.video.style.height = `auto`;
					}
					if(scaleEnd >= 0){
						objs.video.style.position = "relative";
					}
				}

				sceneInfo[2].objs.sticky.style.position = "relative";

				break;

			case 2: //section2

				//opacity 세팅
				sceneInfo[1].objs.video.style.width = `100%`;
				objs.imgCon.style.opacity = calcValues(values.imgCon_opacity, currentYOffset);
				objs.sticky.style.position ="fixed";
				objs.sticky.style.transition = "0.3s all"
				objs.imgA.style.clip = `rect(0, 0vw, 100vh, 0)`; 
				objs.container.style.background = "transparent";
			
				if(scrollRatio <= 0.2){
					sceneInfo[1].objs.video.style.position ="fixed";
				} 

				//이미지 변환 애니메이션
				if(scrollRatio >= 0.2){
					objs.imgA.style.clip = `rect(0, ${calcValues(values.imgA_clip, currentYOffset)}vw, 100vh, 0)`; 
				} 

				if(scrollRatio >= 0.35){
					objs.imgText.style.opacity = calcValues(values.imgText_opacity, currentYOffset);
					objs.imgText.style.transform = `translate3d(-50%, ${calcValues(values.imgText_transition, currentYOffset)}%, 0)`;
				} 

				if(scrollRatio >= 0.6){
					objs.imgB.style.left = `${calcValues(values.imgB_left, currentYOffset)}%`
				} 

				if(scrollRatio >= 0.7){
					//objs.sticky.style.position = "sticky";
					sceneInfo[3].objs.title.style.opacity = calcValues(values.title3_opacity, currentYOffset);
					sceneInfo[3].objs.title.style.transform = `translate3d(0, ${calcValues(values.title3_transition, currentYOffset)}%, 0)`;
				} 
				if(scrollRatio >= 0.9){
					objs.sticky.style.position = "sticky";
					objs.sticky.style.position ="relative";
					objs.container.style.background = "black";
				} 

				//모바일
				if(window.innerWidth < 768){
					//section1 비디오 고정 해제
					sceneInfo[0].objs.video.style.position = "relative";
					objs.container.style.position="relative"

					objs.imgText2.style.opacity = "0";

					objs.imgCon2.style.opacity = calcValues(values.imgCon2_opacity, currentYOffset);

					objs.imgC.style.transform = `translateY(0%)`; 

					if(scrollRatio >= 0.1){
						objs.imgD.style.height = `${calcValues(values.imgD_height, currentYOffset)}%`; 
					} 
					if(scrollRatio > 0.4){
						objs.imgC.style.transform = `translateY(-${calcValues(values.imgD_translate, currentYOffset)}%)`; 
					} 

					if(scrollRatio >= 0.5){

						objs.sticky.style.position = "fixed";
						objs.imgText2.style.opacity = calcValues(values.imgText2_opacity, currentYOffset);
						objs.imgText2.style.transform =  `translate3d(0, ${calcValues(values.imgText2_transition, currentYOffset)}%, 0)`;
					} 
					if(scrollRatio >= 0.7){

						objs.sticky.style.position = "sticky";
					} 

					// section3 텍스트 애니메이션
					if(scrollRatio >= 0.55){
						sceneInfo[3].objs.title.style.opacity = calcValues(values.title3_opacity_mo, currentYOffset);
						sceneInfo[3].objs.title.style.transform = `translate3d(0, ${calcValues(values.title3_transition_mo, currentYOffset)}%, 0)`;
					} 
				}
			
				break;

				case 3: //section3

					//section1 비디오 고정 해제
					sceneInfo[1].objs.video.style.position ="relative";
					//sceneInfo[2].objs.container.style.background = "#000";
					sceneInfo[2].objs.sticky.style.position ="absolute";

					//영상 넓어지는 애니메이션
					values.videoHeight[2].start = (window.innerHeight / 2) / scrollHeight - 0.2; 
					values.videoHeight[2].end = values.videoHeight[2].start + 0.4;
					values.videoWidth[2].start = (window.innerHeight / 2) / scrollHeight - 0.5; 
					values.videoWidth[2].end = values.videoWidth[2].start + 0.5;

					objs.video.style.width = `${calcValues(values.videoWidth, currentYOffset)}%`;

					//영상 스크롤 시작시 영상 재생
					const rectStart3Y = objs.video.getBoundingClientRect().top
					const videoHeight2 = objs.video.scrollHeight;
					
					if(videoHeight2 + 0.2 <= rectStart3Y){
						objs.video.play();
						objs.video.style.width = "1280px";
					} 

					// section4 영상 보일시 영상 재생
					const rectStart4Y = sceneInfo[4].objs.video.getBoundingClientRect().top
					const videoHeight3 = sceneInfo[4].objs.video.scrollHeight;
					
					if(videoHeight3 <= rectStart4Y){
						sceneInfo[4].objs.video.play();
					}
					
					//  section4 배경 색
					if(scrollRatio >= 0.7){
						sceneInfo[4].objs.container.classList.add("on");	
						objs.title2.style.opacity = calcValues(values.title2_opacity, currentYOffset);
						objs.title2.style.transform = `translate3d(0, ${calcValues(values.title2_transition, currentYOffset)}%, 0)`;
					}
					if(scrollRatio <= 0.5){
						sceneInfo[4].objs.container.classList.remove("on");
					}

				//모바일
				if(window.innerWidth < 768){
					objs.title2.style.transform = `translate3d(0, 0, 0)`;
					objs.video.style.width = `100%`;
					//objs.video.style.height = `auto`;

					if(videoHeight2 + 0.2 <= rectStart3Y){
						objs.video.play();
						objs.video.style.width = "100%";
					} 

					if(scrollRatio >= 0){
						objs.title.style.opacity = 1;
						objs.title.style.transform = `translate3d(0, 0, 0)`;
					} 

					//  section4 배경 색
					if(scrollRatio >= 0){
						sceneInfo[4].objs.container.classList.add("on");
						objs.title2.style.opacity = calcValues(values.title2_opacity_m, currentYOffset);
						objs.title2.style.transform = `translate3d(0, ${calcValues(values.title2_transition_m, currentYOffset)}%, 0)`;
					}
					if(scrollRatio <= 0.5){
						sceneInfo[4].objs.container.classList.remove("on");
					}
				}

				break;

			case 4: //section5
				
				// section5 배경
				sceneInfo[4].objs.container.classList.add("on");

				// 영상 리플레이
				const videoStart = objs.video.getBoundingClientRect().top / scrollHeight;
				if(videoStart <= 0){
					objs.video.play();
				}

			break;
	
		case 5:

			objs.imgBg.style.height = `${objs.phone.offsetHeight - 7}px`;
			
			// 가로세로 모두 꽉 차게 하기 위해 여기서 세팅
			const widthRatio = window.innerWidth / objs.imgArea.offsetWidth;
			const heightRatio = window.innerHeight /objs.imgArea.offsetHeight;
			let canvasScaleRatio;

			if (widthRatio <= heightRatio) {
				// 캔버스보다 브라우저 창이 홀쭉한 경우
				canvasScaleRatio = heightRatio;
			} else {
				// 캔버스보다 브라우저 창이 납작한 경우
				canvasScaleRatio = widthRatio;
			}

			const recalculatedInnerWidth = document.body.offsetWidth / canvasScaleRatio;
			const recalculatedInnerHeight = window.innerHeight / canvasScaleRatio;

			objs.imgArea.style.transform = `scale(${canvasScaleRatio})`;

			if(!values.rectStartY){
				values.rectStartY = sceneInfo[6].objs.container.offsetTop  - prevScrollHeight;

				values.phone_scale[0] = canvasScaleRatio;
				values.phone_scale[1] = document.body.offsetWidth / (2 * objs.imgArea.offsetWidth);
				values.phone_scale[2].start = 0
				values.phone_scale[2].end = values.rectStartY / scrollHeight - 0.7;
			}
			if(scrollRatio >= 0){
				objs.imgArea.style.position ="fixed";
			}

			objs.imgCon.style.height =`${objs.container.offsetHeight}px`;

			objs.imgArea.style.top = `${-(objs.imgArea.offsetHeight - objs.imgArea.offsetHeight * canvasScaleRatio) / 2}px`;
			objs.imgArea.style.marginTop = `0`;

			objs.imgArea.style.transform = `scale(${calcValues(values.phone_scale, currentYOffset) + 0.05})`;

			values.title_opacity[2].start = values.phone_scale[2].end - 0.05 ;
			values.title_opacity[2].end = values.phone_scale[2].end  + 0.2;
			values.title_transition[2].start = values.phone_scale[2].end;
			values.title_transition[2].end = values.phone_scale[2].end + 0.2;

			objs.title.style.top = `${objs.imgArea.offsetHeight + 200}px`;
			objs.title.style.opacity = calcValues(values.title_opacity, currentYOffset);
			objs.title.style.transform = `translate3d(0, ${calcValues(values.title_transition, currentYOffset)}%, 0) scale(${1.05 + document.body.offsetWidth / (2 * objs.imgArea.offsetWidth)})`;

			if(scrollRatio >values.phone_scale[2].end && values.phone_scale[2].end > 0){
				objs.imgArea.style.position = "absolute";
				objs.imgArea.style.marginTop = `${scrollHeight * (values.rectStartY / scrollHeight - 0.7)}px`;
			}


			// 브라우저 넓이 좁을때
			if(window.innerWidth > 1024){
				if( 1350 >= window.innerWidth){
					values.phone_scale[2].start = 0
					values.phone_scale[2].end = values.rectStartY / scrollHeight - 0.8;
		
					if(scrollRatio >values.phone_scale[2].end && values.phone_scale[2].end > 0){
						objs.imgArea.style.position = "absolute";
						objs.imgArea.style.marginTop = `${scrollHeight * (values.rectStartY / scrollHeight - 0.8)}px`;
					}
				}
			}

			//모바일
			if(window.innerWidth <= 1024){
				// objs.imgArea.style.top = `${-(objs.imgArea.offsetHeight - objs.imgArea.offsetHeight * canvasScaleRatio) / 2}px`

				if(window.innerWidth <= window.innerHeight){ 
					if(scrollRatio >= 0){
						objs.imgArea.style.position ="fixed";
						objs.imgArea.style.top = `${-(objs.imgArea.offsetHeight - objs.imgArea.offsetHeight * canvasScaleRatio) / 2}px`
					}

					objs.imgArea.style.transform = `scale(${calcValues(values.phone_scale, currentYOffset) + 0.2})`;

					values.title_opacity[2].start = values.phone_scale[2].end;
					values.title_opacity[2].end = values.phone_scale[2].end + 0.05;
					values.title_transition[2].start = values.phone_scale[2].end;
					values.title_transition[2].end = values.phone_scale[2].end + 0.05;
					
					objs.title.style.top = `${objs.imgArea.offsetHeight + 100}px`;
					objs.title.style.opacity = calcValues(values.title_opacity, currentYOffset);
					objs.title.style.transform = `translate3d(0, ${calcValues(values.title_transition, currentYOffset)}%, 0) scale(${1 + document.body.offsetWidth / (2 * objs.imgArea.offsetWidth)})`;

					values.phone_scale[2].start = 0
					values.phone_scale[2].end = values.rectStartY / scrollHeight - 0.62;

					if(scrollRatio >values.phone_scale[2].end && values.phone_scale[2].end > 0){
						objs.imgArea.style.position = "relative";
						objs.imgArea.style.marginTop = `${scrollHeight * 0.38}px`;
					}
				} 
				if(window.innerWidth > window.innerHeight && window.innerHeight < 768){ // 모바일 가로모드
					objs.imgArea.style.transform = `scale(${calcValues(values.phone_scale, currentYOffset) + 0.2})`;

					values.title_opacity[2].start = values.phone_scale[2].end;
					values.title_opacity[2].end = values.phone_scale[2].end + 0.05;
					values.title_transition[2].start = values.phone_scale[2].end;
					values.title_transition[2].end = values.phone_scale[2].end + 0.05;
					
					objs.title.style.top = `${objs.imgArea.offsetHeight + 100}px`;
					objs.title.style.opacity = calcValues(values.title_opacity, currentYOffset);
					objs.title.style.transform = `translate3d(0, ${calcValues(values.title_transition, currentYOffset)}%, 0) scale(${1 + document.body.offsetWidth / (2 * objs.imgArea.offsetWidth)})`;

					values.phone_scale[2].start = 0
					values.phone_scale[2].end = values.rectStartY / scrollHeight - 0.65;

					if(scrollRatio >values.phone_scale[2].end && values.phone_scale[2].end > 0){
						objs.imgArea.style.position = "absolute";
						objs.imgArea.style.marginTop = `${scrollHeight * 0.35}px`;
					}

					if(scrollRatio === values.phone_scale[2].end ){
						objs.title.style.opacity = calcValues(values.title_opacity, currentYOffset);
						objs.title.style.opacity = "1";
						objs.title.style.transform = `translate3d(0, 20%, 0) scale(${1 + document.body.offsetWidth / (2 * objs.imgArea.offsetWidth)})`;
					}
				}

				if(768 <= window.innerWidth && window.innerWidth <= 1024){

					objs.title.style.transform = `translate3d(0, ${calcValues(values.title_transition, currentYOffset)}%, 0) scale(${1 + document.body.offsetWidth / (2 * objs.imgArea.offsetWidth)})`;

					values.phone_scale[2].start = 0
					values.phone_scale[2].end = values.rectStartY / scrollHeight - 0.65;

					if(scrollRatio > values.phone_scale[2].end && values.phone_scale[2].end > 0){
						objs.imgArea.style.position = "absolute";
						objs.imgArea.style.marginTop = `${scrollHeight * 0.35}px`;
					}

					if(scrollRatio === values.phone_scale[2].end ){
						objs.title.style.transform = `translate3d(0, 20%, 0) scale(${1 + document.body.offsetWidth / (2 * objs.imgArea.offsetWidth)})`;
					}
				}
			} 
			break;
		}
	}

	function scrollLoop() {
		enterNewScene = false;
		prevScrollHeight = 0;

		for (let i = 0; i < currentScene; i++) {
			prevScrollHeight += sceneInfo[i].scrollHeight;
		}

		if (delayedYOffset < prevScrollHeight + sceneInfo[currentScene].scrollHeight) {
		//	document.body.classList.remove('scroll-effect-end');
		}

		if (delayedYOffset > prevScrollHeight + sceneInfo[currentScene].scrollHeight) {
			enterNewScene = true;
			if (currentScene === sceneInfo.length - 1) {
			//	document.body.classList.add('scroll-effect-end');
			}
			if (currentScene < sceneInfo.length - 1) {
				currentScene++;
			}
			document.body.setAttribute('class', `is-show__section${currentScene}`);
		}

		if (delayedYOffset < prevScrollHeight) {
			enterNewScene = true;
			// 브라우저 바운스 효과로 인해 마이너스가 되는 것을 방지(모바일)
			if (currentScene === 0) return;
			currentScene--;
			document.body.setAttribute('class', `is-show__section${currentScene}`);
		}

		if (enterNewScene) return;

		playAnimation();
	}

	function loop() {
		delayedYOffset = delayedYOffset + (yOffset - delayedYOffset) * acc;

		if (!enterNewScene) {
			if (currentScene === 0 || currentScene === 2) {
				const currentYOffset = delayedYOffset - prevScrollHeight;
				const objs = sceneInfo[currentScene].objs;
				const values = sceneInfo[currentScene].values;
			}
		}

		if (delayedYOffset < 1) {
				scrollLoop();
		}

		rafId = requestAnimationFrame(loop);

		if (Math.abs(yOffset - delayedYOffset) < 1) {
			cancelAnimationFrame(rafId);
			rafState = false;
		}
	}

	window.addEventListener('load', () => {
		setLayout(); 
			// 중간에서 새로고침 했을 경우 상단 이동
			let tempYOffset = yOffset;
			let tempScrollCount = 0;
			if (tempYOffset > 0) {
					let siId = setInterval(() => {
							scrollTo(0, 0);
							tempYOffset += 5;

							if (tempScrollCount > 20) {
									clearInterval(siId);
							}
							tempScrollCount++;
					}, 20);
			}
			document.body.classList.remove('before-load');

			setLayout();

       window.addEventListener('scroll', () => {
				yOffset = window.pageYOffset;
				scrollLoop();
				scrollRotate();

  			if (!rafState) {
  				rafId = requestAnimationFrame(loop);
  				rafState = true;
  			}
  		});

  		window.addEventListener('orientationchange', () => {
			scrollTo(0, 0);
			setTimeout(() => {
				window.location.reload();
			}, 500);
  		});
	});

}
parallax();
